<template>
    <div>
        <div class="border-t-2 p-3">
            <p class="mb-3">{{ notification.title }}</p>

            <p class="text-base font-light mb-3">{{ notification.description }}</p>

            <button
                @click="getNotificationUrl(notification.link)"
                type="button"
                class="btn btn-purple leading-5 h-auto"
            >
                {{ getButtonText() }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    notification: Object
  },
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  methods: {
    getNotificationUrl: function (link) {
      window.open(link, '_blank')
    },
    getButtonText () {
      if (this.windowWidth < 992) {
        return `${this.notification.body}, toque aqui`
      }
      return `${this.notification.body}, clique aqui`
    }
  },
  mounted () {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>
